"use client";

import { useState } from "react";
import TabList from "./TabList";
import Slider from "../../common/components/Slider";
import { useTranslations } from "next-intl";

export default function PageMenuWithTabList({
  menuItems,
}: {
  menuItems: Array<{
    title: string;
    children: any;
  }>;
}) {
  const t = useTranslations();
  const [activeIndex, setActiveIndex] = useState(0);
  const slidesForTab = menuItems[activeIndex]?.children;
  return (
    <div className="ml-md-1">
      {menuItems?.length > 1 && (
        <TabList
          appearance="simple"
          tabs={menuItems?.map((menuItem, index) => ({
            title: menuItem.title || t("unknown"),
            isActive: activeIndex === index,
            onClick: () => {
              setActiveIndex(index);
            },
          }))}
        />
      )}
      <Slider autoPlay={false} navigation={true} slidesPerView={3}>
        {slidesForTab}
      </Slider>
    </div>
  );
}
